module.exports = __webpack_public_path__ + "static/media/mbys_sho_of_bre.04a099c2.png";